/*
 * File: Spinner.styles.js
 * Project: seesaw-marketplace-app
 *
 * Created by Brendan Michaelsen on February 6, 2022 at 12:13 AM
 * Copyright © 2022 Seesaw Technologies, LLC. All rights reserved.
 *
 * Last Modified: July 20, 2022 at 4:04 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	display: grid;
	place-items: center;
	height: inherit;
	align-content: center;
	width: 100%;
	height: 100%;
`;
